import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { FloorplansType } from "operations/schema/schema";
import { asyncQueries } from "./floorplans.queries";

export interface State {
  floorplans: FloorplansType[];
  loading: boolean;
  error: string | null;
}

const initialState: State = {
  floorplans: [],
  loading: false,
  error: null,
};

const floorplansSlice = createSlice({
  name: "floorplans",
  initialState,
  reducers: {
    setFloorplans: (state, action: PayloadAction<FloorplansType[]>) => {
      state.floorplans = action.payload;
      state.error = null;
    },
    clearFloorplans: (state) => {
      state.floorplans = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
  builder
    .addCase(asyncQueries.getFloorplansByEquipmentId.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(asyncQueries.getFloorplansByEquipmentId.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(asyncQueries.getFloorplansByEquipmentId.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
},
});

export const { setFloorplans, clearFloorplans } = floorplansSlice.actions;

export const selectFloorplans = (state: RootState) => state.floorplans.floorplans;
export const selectFloorplansLoading = (state: RootState) => state.floorplans.loading;
export const selectFloorplansError = (state: RootState) => state.floorplans.error;

export default floorplansSlice.reducer;
